import React from "react";
import { Switch, Route, withRouter } from "react-router-dom";
import withMotion from "../../../Utils/withMotion";

//Pages
import PageNotFound from "../../../404";
import Patios from "./Patios";
import Driveways from "./Driveways";
import GardenWalls from "./GardenBeds";
import PoolDecks from "./PoolDecks";
import Steps from "./Steps";
import Walkways from "./Walkways";
import FireFeatures from "./FireFeatures";

//CTA
import { ViewPavers } from "../../../CTA/CTA";

const ServicesPages = () => {
  return (
    <>
      <Switch>
        <Route exact component={Patios} path="/services/patios" />
        <Route exact component={Driveways} path="/services/driveways" />
        <Route exact component={GardenWalls} path="/services/garden-walls" />
        <Route exact component={PoolDecks} path="/services/pool-decks" />
        <Route exact component={Steps} path="/services/steps-and-coping" />
        <Route exact component={Walkways} path="/services/walkways" />
        <Route exact component={FireFeatures} path="/services/firefeatures" />
        <Route exact component={PageNotFound} path="*" />
      </Switch>
      <ViewPavers />
    </>
  );
};

export default withRouter(withMotion(ServicesPages));
